module.exports = __webpack_public_path__ + "img/0.c5acf7c1.jpg";